export default __webpack_public_path__ + "static/media/3.4b01d964.webp";